import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chat-window" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatWindow = _resolveComponent("ChatWindow")!
  const _component_Talking = _resolveComponent("Talking")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ChatWindow, {
      "current-user-id": "me",
      rooms: _ctx.rooms,
      messages: _ctx.messages,
      "rooms-loaded": true,
      "messages-loaded": true,
      "show-emojis": false,
      "show-files": false,
      "show-audio": false,
      "single-room": true,
      onSendMessage: _ctx.onSendMessage,
      "room-id": "123",
      height: "100%"
    }, null, 8, ["rooms", "messages", "onSendMessage"]),
    (_ctx.isTalking)
      ? (_openBlock(), _createBlock(_component_Talking, {
          key: 0,
          onStopTalking: _cache[0] || (_cache[0] = (e) => _ctx.stopTalking(e))
        }))
      : _createCommentVNode("", true)
  ]))
}